module.exports = __webpack_public_path__ + "static/media/fellowship.a2190bdc.jpg";